<div
  class="component-container text-cool-grey h-[100%] flex flex-col justify-center items-center space-y-[2.4rem]">
  <div
    class="questions-form-container md:w-[80%] w-full flex flex-col justify-center items-center">
    <div
      class="heading font-poppins font-bold mb-[2.4rem] flex justify-center ">
      Your Details
    </div>
    <div
      *ngIf="obQuestionLoader; else displayAdultForm"
      class="loader w-full flex justify-center items-center"
    >
      <mat-spinner
        [diameter]="100"
        mode="indeterminate"
        strokeWidth="5"
      />
    </div>
    <ng-template
      #displayAdultForm
    >
      <div
        *ngFor="let question of questionList,let i = index"
        [ngSwitch]="question.dataType"
        class="w-full"
      >
        <ng-container
          *ngSwitchCase="1"
        >
          <app-dropdown
            (checkForErrors)="checkForErrors($event)"
            [controlName]="''+question.key"
            [error]="errorMessages[''+question.key]"
            [label]="question.question"
            [options]="question.options"
            [parentFormGroup]="form"
            [tooltipText]="question.tooltipText"
            class="input"
            placeholder="Select all that apply"
            type="small"
          />
        </ng-container>
        <ng-container
          *ngSwitchCase="2"
        >
          <app-dropdown
            (checkForErrors)="checkForErrors($event)"
            [controlName]="''+question.key"
            [enableMultiple]="true"
            [error]="errorMessages[''+question.key]"
            [label]="question.question"
            [options]="question.options"
            [parentFormGroup]="form"
            [tooltipText]="question.tooltipText"
            class="input"
            placeholder="Select all that apply"
            type="small"
          />
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="selfDescriptionOthersSelected && question.key=== 'selfDescribe'"
            [controlName]="''+question.key+'_Other'"
            [error]="errorMessages[''+question.key+'_Other']"
            [maxLength]="validation.onboarding.other.length.max"
            [parentFormGroup]="form"
            label="Other race"
            placeholder="Enter your text here"
            showCharCount="true"
            type="small"
          ></app-text-input>
          <app-text-area-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="underGraduateDegreesOthersSelected && question.key=== 'undergraduateDegrees'"
            [controlName]="''+question.key+'_Other'"
            [error]="errorMessages[''+question.key+'_Other']"
            [maxLength]="validation.onboarding.other.length.max"
            [parentFormGroup]="form"
            label="Other undergraduate degree (abbreviation)"
            placeholder="Enter your text here"
            showCharCount="true"
            type="small"
          ></app-text-area-input>
          <app-text-area-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="mastersDegreesOthersSelected && question.key==='masterDegrees'"
            [controlName]="''+question.key+'_Other'"
            [error]="errorMessages[''+question.key+'_Other']"
            [maxLength]="validation.onboarding.other.length.max"
            [parentFormGroup]="form"
            label="Other Master's degree (abbreviation)"
            placeholder="Enter your text here"
            showCharCount="true"
            type="small"
          ></app-text-area-input>
          <app-text-area-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="doctorateDegreesOthersSelected && question.key=== 'doctorateDegrees'"
            [controlName]="''+question.key+'_Other'"
            [error]="errorMessages[''+question.key+'_Other']"
            [maxLength]="validation.onboarding.other.length.max"
            [parentFormGroup]="form"
            label="Other Doctorate degree (abbreviation)"
            placeholder="Enter your text here"
            showCharCount="true"
            type="small"
          ></app-text-area-input>
          <app-text-area-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="professionalLicensesOthersSelected && question.key=== 'professionalLicenses'"
            [controlName]="''+question.key+'_Other'"
            [error]="errorMessages[''+question.key+'_Other']"
            [maxLength]="validation.onboarding.other.length.max"
            [parentFormGroup]="form"
            label="Other professional license and/or certification (abbreviation)"
            placeholder="Enter your text here"
            showCharCount="true"
            type="small"
          ></app-text-area-input>
          <app-text-area-input
            (checkForErrors)="checkForErrors($event)"
            *ngIf="describeOrgOtherSelected && question.key=== 'organizationType'"
            [controlName]="''+question.key+'_Other'"
            [error]="errorMessages[''+question.key+'_Other']"
            [maxLength]="validation.onboarding.other.length.max"
            [parentFormGroup]="form"
            label="Describe your organization?"
            placeholder="Enter your text here"
            showCharCount="true"
            type="small"
          ></app-text-area-input>
        </ng-container>
        <ng-container
          *ngSwitchCase="4"
        >
          <app-text-input
            (checkForErrors)="checkForErrors($event)"
            [controlName]="''+question.key"
            [error]="errorMessages[''+question.key]"
            [label]="question.question"
            [maxLength]="validation.onboarding.other.length.max"
            [minLength]="validation.onboarding.other.length.min"
            [parentFormGroup]="form"
            [tooltipText]="question.tooltipText"
            placeholder="Type here"
            showCharCount="true"
            type="small"
          ></app-text-input>
        </ng-container>
      </div>
    </ng-template>
    <div class="action-section w-full flex flex-col items-center">
      <app-primary-button
        (handleClick)="continue()"
        [isLoading]="saveAnswersLoading"
        class="continue-btn w-[70%] flex justify-center"
        type="small"
      >
        CONTINUE
      </app-primary-button>
    </div>
    <span
      class="note font-work-sans font-light flex justify-center text-center">
      Required fields are marked with an asterisk (*)
    </span>
  </div>
</div>
